import BaseViewController from "./base-view-controller";

class ConsultationDermIntakeViewController extends BaseViewController {
  prepareSubmit(values) {
    const EMPTY_TREATMENT_HISTORY = "empty_treatment_history";
    const updatedValues = { ...values };
    delete updatedValues[EMPTY_TREATMENT_HISTORY];

    if (Object.values(this.appData.dermTreatmentData)[0]?.length === 0) {
      updatedValues[EMPTY_TREATMENT_HISTORY] = "Y";
    }

    return updatedValues;
  }

  preprocessScreenData() {
    let updatedFields = [...this.screen.fields];

    if (
      !Object.values(this.appData.dermTreatmentData)[0] ||
      Object.values(this.appData.dermTreatmentData)[0].length === 0
    ) {
      if (
        !this.screen.fields.find(scr => scr.name === "empty_treatment_history")
      ) {
        updatedFields.splice(updatedFields.length - 2, 0, {
          name: "empty_treatment_history",
          text: this.appData.settings.translations.no_treatment_included,
          type: "cellWithSubtitle"
        });
      }
    } else {
      updatedFields = updatedFields.filter(
        field => field.name !== "empty_treatment_history"
      );
      const treatmentFields = Object.values(
        this.appData.dermTreatmentData
      )[0].map((treatment, index) => {
        return {
          type: "treatmentCell",
          title: treatment,
          name: treatment,
          formulation:
            this.appData.dermTreatmentData[
              Object.keys(this.appData.dermTreatmentData)[1]
            ][index],
          frequency:
            this.appData.dermTreatmentData[
              Object.keys(this.appData.dermTreatmentData)[2]
            ][index],
          usingNow:
            this.appData.dermTreatmentData[
              Object.keys(this.appData.dermTreatmentData)[4]
            ][index],
          actionToEdit: this.screen.fields.find(
            scr => scr.name === "add_treatment_link"
          ).action
        };
      });
      updatedFields.splice(updatedFields.length - 2, 0, ...treatmentFields);
    }
    this.screen = {
      ...this.screen,
      fields: updatedFields
    };
  }
}

export default ConsultationDermIntakeViewController;
